import { forwardRef, TextareaHTMLAttributes } from 'react';
import styled from 'styled-components';

export interface ITextareaInput extends TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const TextareaStyled = styled.textarea`
  box-sizing: border-box;
  width: 100%;

  border: 1px solid #e1e1e1;
  border-radius: 6px;
  padding: 8px 12px;

  color: #787676;

  &:focus {
    outline: none;
    border-color: #0b68fe;
  }

  &:focus::placeholder {
    color: transparent;
  }

  //TODO: use BodyBigRegularText
  margin: 0;
  font-family: 'Noto Sans', sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: normal;
`;

export const TaskFormTextAreaInput = forwardRef<HTMLTextAreaElement, ITextareaInput>(({ ...rest }, ref) => {
  return <TextareaStyled ref={ref} {...rest} />;
});
